import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TrainingGroupIddProgressModel } from 'src/app/models/dashboard/training-groups-idd-progress.model';
import { TableColumn } from 'src/app/models/table-column.model';
import { DashboardWidgetsDataService } from 'src/app/services/dashboard-widget-data.service';
import { getDurationStringHours } from 'src/app/utils/duration-formatter.utils';

@Component({
    selector: 'app-training-group-qualification-status-widget',
    templateUrl: './training-group-qualification-status-widget.component.html',
    styleUrl: './training-group-qualification-status-widget.component.scss',
    standalone: false
})
export class TrainingGroupQualificationStatusWidgetComponent {
  trainingGroupsQualificationData: any[] = [];

  trainingGroupsQualificationColumns: TableColumn[] = [
    {
      caption: this.translateService.instant('COMMON.FIELDS.TRAINING-GROUP'),
      dataField: 'trainingGroupName',
      dataType: 'string',
      disableFiltering: true,
    },
    {
      caption: this.translateService.instant('COMMON.FIELDS.PROGRESS'),
      dataField: 'progress',
      dataType: 'string',
      disableFiltering: true,
    },
    {
      caption: this.translateService.instant('COMMON.FIELDS.PROGRESS') + ' %',
      dataField: 'progressPercentage',
      dataType: 'string',
      name: 'progressPercentage',
      calculateDisplayValue: (data: any): string => {
        return data.progressPercentage + ' %';
      },
      disableFiltering: true,
    },
    {
      caption: this.translateService.instant('COMMON.FIELDS.PROGRESS-BAR'),
      dataField: 'progressPercentage',
      dataType: 'string',
      name: 'progressPercentageBar',
      cellTemplate: 'progressBullet',
      disableFiltering: true,
    },
  ];

  constructor(
    private translateService: TranslateService,
    private router: Router,
    private dashboardWidgetsDataService: DashboardWidgetsDataService
  ) {
    
  }

  ngOnInit() {
    this.dashboardWidgetsDataService.getComplianceCoursesProgress().subscribe(data => {
      if (data) {
        this.trainingGroupsQualificationData = data
        .map((data, index) => {
          return {
            id: index,
            trainingGroupName: data.trainingGroupName,
            trainingGroupId: data.trainingGroupId,
            progress: getDurationStringHours(
              data.iddTimeMinutesReached,
              data.iddTimeMinutesTarget
            ),
            progressPercentage: Math.min(
              Math.round(
                (data.iddTimeMinutesReached / data.iddTimeMinutesTarget) *
                  100
              ),
              100
            ),
          };
        })
        .sort((a, b) => {
          if (a.trainingGroupName < b.trainingGroupName) {
            return -1;
          }
          if (a.trainingGroupName > b.trainingGroupName) {
            return 1;
          }
          return 0;
        });
      }
    });
  }

  onTrainingGroupClick(event: any) {
    const qualificationData = this.trainingGroupsQualificationData.find(
      (data) => data.id === event
    );

    if (qualificationData) {
      this.router.navigate(['/employee'], {
        queryParams: { trainingGroupId: qualificationData.trainingGroupId },
      });
    }
  }
}
